module.exports = __webpack_public_path__ + "about-us-b998e096/website-2142863eea0f6948afb1bb3add461d4c.svg";